import React, {useEffect, useMemo, useState} from "react";
import {ICmpEdt} from "../Interfaces/ICmpEdt";
import AxiosServices from "../Services/axiosServices";
import {useGlobal} from "../config/GlobalContext";

const CompetitionSelector = () => {

    const [competitions, setCompetitions] = useState<ICmpEdt[]>([]);
    const [showArchived, setShowArchived] = useState(false);
    const {currentCmpEdt, setCurrentCmpEdt, setGroups, setFilteredMatches, setHasGroups} = useGlobal();

    useEffect(() => {
        AxiosServices.getCpmEdt((data: ICmpEdt[]) => {
            setCompetitions(data);
            const active = data.filter((c: ICmpEdt) => c.etOpn === 'O');
            if (active.length > 0 && currentCmpEdt === 0) {
                const defaultIdt = Math.max(...active.map((c: ICmpEdt) => c.Idt));
                const defaultCmp = active.find((c: ICmpEdt) => c.Idt === defaultIdt)!;
                handleSelect(defaultCmp);
            }
        }).catch(err => console.error('getCpmEdt failed:', err));
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleSelect = (cmp: ICmpEdt) => {
        setCurrentCmpEdt(cmp.Idt);
        setHasGroups(cmp.EdtGrp === 'O');
        setFilteredMatches("");
        AxiosServices.getGroups(setGroups, cmp.Idt)
            .then()
            .catch(err => console.error(err));
    };

    const {active, archived} = useMemo(() => {
        const sortByIdtDesc = (a: ICmpEdt, b: ICmpEdt) => b.Idt - a.Idt;
        return {
            active: competitions.filter(c => c.etOpn === 'O').sort(sortByIdtDesc),
            archived: competitions.filter(c => c.etOpn !== 'O').sort(sortByIdtDesc),
        };
    }, [competitions]);

    if (competitions.length === 0) return null;

    return (
        <div style={{
            padding: "0.75rem 1rem",
            borderBottom: "1px solid rgba(255,255,255,0.1)",
        }}>
            <div style={{
                fontSize: "10px",
                color: "rgba(255,255,255,0.4)",
                textTransform: "uppercase",
                letterSpacing: "0.08em",
                marginBottom: "0.5rem",
            }}>
                Compétition
            </div>
            <div style={{display: "flex", flexDirection: "column", gap: "0.3rem"}}>
                {active.map(renderItem)}
            </div>

            {archived.length > 0 && (
                <>
                    <div
                        onClick={() => setShowArchived(v => !v)}
                        style={{
                            marginTop: "0.6rem",
                            padding: "0.3rem 0.4rem",
                            cursor: "pointer",
                            fontSize: "11px",
                            color: "rgba(255,255,255,0.5)",
                            userSelect: "none",
                            display: "flex",
                            alignItems: "center",
                            gap: "0.3rem",
                        }}
                    >
                        <span style={{
                            display: "inline-block",
                            transform: showArchived ? "rotate(90deg)" : "rotate(0deg)",
                            transition: "transform 0.15s ease",
                        }}>▸</span>
                        Anciennes ({archived.length})
                    </div>
                    {showArchived && (
                        <div style={{display: "flex", flexDirection: "column", gap: "0.3rem"}}>
                            {archived.map(renderItem)}
                        </div>
                    )}
                </>
            )}
        </div>
    );

    function renderItem(c: ICmpEdt) {
        const isSelected = c.Idt === currentCmpEdt;
        const isArchived = c.etOpn !== 'O';
        return (
            <div
                key={c.Idt}
                onClick={() => handleSelect(c)}
                style={{
                    cursor: "pointer",
                    padding: "0.4rem 0.6rem",
                    borderRadius: "6px",
                    background: isSelected ? "rgba(183,207,225,0.2)" : "transparent",
                    borderLeft: isSelected ? "3px solid #b7cfe1" : "3px solid transparent",
                    color: isSelected ? "#b7cfe1" : isArchived ? "rgba(255,255,255,0.4)" : "rgba(255,255,255,0.65)",
                    fontSize: "13px",
                    fontWeight: isSelected ? 500 : 400,
                    fontStyle: isArchived ? "italic" : "normal",
                    transition: "all 0.15s ease",
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                }}
                title={c.Lib}
            >
                {c.Lib}
            </div>
        );
    }
};

export default CompetitionSelector;
